import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

// ============================================================
// UPDATE THESE URLs WHEN YOUR APP IS LIVE
// ============================================================
export const APP_STORE_URL = '#'; // e.g. https://apps.apple.com/app/anyelo-elite/id123456789
export const PLAY_STORE_URL = '#'; // e.g. https://play.google.com/store/apps/details?id=com.anyeloelite
export const SMART_LINK_URL = 'https://anyelo-elite-1.preview.emergentagent.com'; // Replace with onelink.to or branch.io smart link
// ============================================================

export function AppStoreButton({ className = '', size = 'md' }) {
  const h = size === 'lg' ? 'h-[52px]' : 'h-[44px]';
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="appstore-button"
      className={`inline-flex items-center gap-2.5 px-5 rounded-xl border border-white/15 hover:border-white/25 transition-all duration-200 hover:-translate-y-0.5 active:scale-95 ${h} ${className}`}
      style={{ backgroundColor: '#0A0A0A' }}
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0" fill="white">
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
      </svg>
      <div className="flex flex-col leading-tight">
        <span className="text-[0.6rem] text-white/60 font-normal" style={{ fontFamily: 'Figtree, sans-serif' }}>
          Download on the
        </span>
        <span className="text-sm font-semibold text-white -mt-0.5" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          App Store
        </span>
      </div>
    </a>
  );
}

export function PlayStoreButton({ className = '', size = 'md' }) {
  const h = size === 'lg' ? 'h-[52px]' : 'h-[44px]';
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="playstore-button"
      className={`inline-flex items-center gap-2.5 px-5 rounded-xl border border-white/15 hover:border-white/25 transition-all duration-200 hover:-translate-y-0.5 active:scale-95 ${h} ${className}`}
      style={{ backgroundColor: '#0A0A0A' }}
    >
      <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0" fill="none">
        <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92z" fill="#4285F4"/>
        <path d="M17.194 8.57L5.716.817c-.452-.305-.91-.466-1.343-.424L14.58 10.6l2.614-2.03z" fill="#EA4335"/>
        <path d="M17.194 15.43L14.58 13.4 4.373 23.607c.433.042.89-.12 1.343-.424l11.478-7.753z" fill="#34A853"/>
        <path d="M21.393 12c0-.711-.384-1.43-1.076-1.898l-3.123-2.113L14.58 10.6 17.194 13.4l-3.123 2.032 3.123 2.113c.692-.468 1.076-1.187 1.076-1.898l.123-.647-.123-.647V12z" fill="#FBBC05"/>
      </svg>
      <div className="flex flex-col leading-tight">
        <span className="text-[0.6rem] text-white/60 font-normal" style={{ fontFamily: 'Figtree, sans-serif' }}>
          GET IT ON
        </span>
        <span className="text-sm font-semibold text-white -mt-0.5" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Google Play
        </span>
      </div>
    </a>
  );
}

export function SmartQRCode({ size = 160, className = '' }) {
  return (
    <div className={`inline-flex flex-col items-center gap-3 ${className}`}>
      <div className="p-3 rounded-2xl bg-white">
        <QRCodeSVG
          value={SMART_LINK_URL}
          size={size}
          level="M"
          bgColor="#FFFFFF"
          fgColor="#030303"
          imageSettings={{
            src: '/logo.png',
            height: size * 0.2,
            width: size * 0.2,
            excavate: true,
          }}
        />
      </div>
      <span className="text-xs text-white/40" style={{ fontFamily: 'Figtree, sans-serif' }}>
        Scan to download
      </span>
    </div>
  );
}

export function DownloadSection({ t }) {
  return (
    <div className="flex flex-col items-center gap-6 sm:gap-8">
      {/* QR Code */}
      <SmartQRCode size={140} />

      {/* Store badges */}
      <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <AppStoreButton size="lg" />
        <PlayStoreButton size="lg" />
      </div>

      {/* Availability note */}
      <p className="text-xs text-white/30 text-center max-w-xs" style={{ fontFamily: 'Figtree, sans-serif' }}>
        {t ? t('download_note') : 'Available on iOS and Android. Scan the QR code or tap a badge to download.'}
      </p>
    </div>
  );
}
